import type { ApiResponseType, PaginatedResponseType } from '~/types/api'
import api, { apiData } from './api'

export interface CompanyType {
  id: string
  name: string
  slug: string
  domain?: string | null
  logo?: string | null
  favicon?: string | null
  settings?: Record<string, unknown>
  status: 'active' | 'inactive'
  createdAt: string
  updatedAt: string
}

export interface CreateCompanyPayloadType {
  name: string
  slug: string
  domain?: string
  logo?: string
  settings?: Record<string, unknown>
}

export interface UpdateCompanyPayloadType {
  name?: string
  slug?: string
  domain?: string
  logo?: string
  favicon?: string
  settings?: Record<string, unknown>
}

export const companyService = {
  async list(params?: { page?: number; limit?: number }) {
    return apiData(api.get<ApiResponseType<PaginatedResponseType<CompanyType>>>('/companies', { params }))
  },

  async get(id: string) {
    return apiData(api.get<ApiResponseType<CompanyType>>(`/companies/${id}`))
  },

  async create(payload: CreateCompanyPayloadType) {
    return apiData(api.post<ApiResponseType<CompanyType>>('/companies', payload))
  },

  async update(id: string, payload: UpdateCompanyPayloadType) {
    return apiData(api.put<ApiResponseType<CompanyType>>(`/companies/${id}`, payload))
  },

  async delete(id: string) {
    return apiData(api.delete<ApiResponseType<boolean>>(`/companies/${id}`))
  },

  async listUsers(companyId: string) {
    const { data } = await api.get(`/companies/${companyId}/users`)
    return data.data
  },

  async addUser(companyId: string, userId: number, role: string = 'member') {
    const { data } = await api.post(`/companies/${companyId}/users`, { userId, role })
    return data.data
  },

  async updateUserRole(companyId: string, userId: number, role: string) {
    const { data } = await api.put(`/companies/${companyId}/users/${userId}`, { role })
    return data.data
  },

  async removeUser(companyId: string, userId: number) {
    const { data } = await api.delete(`/companies/${companyId}/users/${userId}`)
    return data.data as boolean
  }
}
